import $ from 'jquery';
import ACTION from '../action_constant';
import {ajaxGetWithToken, ajaxPostWithToken} from '../util/ajax';

import API from '../api_config';

const shipmentActions = {
  getShipmentDetails: (shipmentId) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.getShipmentDetails,
        data: {"shipmentId": shipmentId},
        success: (data) => {
          dispatch({
            type: ACTION.SHIPMENT.ADD_SHIPMENT_DETAILS,
            data: data
          });
        },
        error: (error) => {
        }
      });
    }
  },
  clearShipmentDetails : () => {
    return (dispatch) => {
      dispatch({
        type :ACTION.SHIPMENT.ADD_SHIPMENT_DETAILS,
        data : ''
      })
    }
  },

  flagShipments: (params) => {
    return () => {
      const promise =  ajaxPostWithToken({
        url: API.flagShipments,
        data: params,
        success: (data) => {

        },
        error: (error) => {

        }
      });
      return promise;
    }
  },

  getShipmentOffers: (shipmentId) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.getShipmentOffers,
        data: {"shipmentId": shipmentId},
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },

  getAllQuestionAnswere : (url_params) =>{
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.allQuestionAns+ '?shipmentId=' + url_params.shipmentId + '&count=' + url_params.count+ '&offset=' + url_params.offset,
        success: (data) => {
          dispatch({
            type :ACTION.SHIPMENT.ADD_NEW_Q_A,
            data
          })
        },
        error: (error) => {
        }
      });
    }
  },
  answerAQuestion: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.answer,
          data: paramObj,
          success: (data) => {
            dispatch({
              type :ACTION.SHIPMENT.ANSWER_A_QUESTION,
              data :paramObj
            })
          },
          error: (error) => {
          }
      });
    }
  },
  askAQuestion: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.askAQuestion,
          data: paramObj,
          success: (data) => {
            console.log(data);
          },
          error: (error) => {
          }
      });
    }
  },
  viewShipmentDetails: (shipmentId,carrierId) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.viewShipmentDetails,
        data: {"shipmentId": shipmentId,"carrierId": carrierId},
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  acceptDeclineOffer: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.acceptDeclineOffer,
          data: paramObj,
          success: (data) => {
          },
          error: (error) => {
          }
      });
    }
  },
  addEditPickUpDeliveryTime: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.addEditPickUpDeliveryTime,
          data: paramObj,
          success: (data) => {
          },
          error: (error) => {
          }
      });
    }
  },
  acceptDeclineOffer: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.acceptDeclineOffer,
          data: paramObj,
          success: (data) => {
          },
          error: (error) => {
          }
      });
    }
  },
  startHandoff: (paramObj) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.startHandoff + '?shipmentId=' + paramObj.shipmentId,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  amAtPickupLocation: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.amAtPickupLocation,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  completeHandoff: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.completeHandoff,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  reportADelay: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url: API.reportADelay,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  onMyWay: (paramObj) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.IamOnMyWay + '?shipmentId=' + paramObj.shipmentId,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  arrivedDestination: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.arrivedDestination,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  meetsRecipient: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.meetsRecipient,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  completeDelivery: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.completeDelivery,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  addProfileReview: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.addProfileReview,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  flagAQuestion: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.flagAQuestion,
          data: paramObj,
          success: (data) => {
            dispatch({
              type :ACTION.SHIPMENT.FLAG_A_QUESTION,
              data :paramObj
            })
          },
          error: (error) => {
          }
      });
    }
  }
}
module.exports = shipmentActions;



// WEBPACK FOOTER //
// app/shipment/shipment_actions.jsx